/**
 * Utilidades para describir patrones de recurrencia en la UI.
 */

const DIAS_SEMANA: Record<number, string> = {
  1: 'L', 2: 'M', 3: 'Mi', 4: 'J', 5: 'V', 6: 'S', 7: 'D',
};

export function describirPatron(actividad: {
  patron_recurrencia?: string;
  dia_mes?: number;
  dias_semana?: string;
}): string {
  if (!actividad.patron_recurrencia) return '';

  switch (actividad.patron_recurrencia) {
    case 'DIARIO':
      return 'Diario';

    case 'SEMANAL': {
      if (!actividad.dias_semana) return 'Semanal';
      const dias = actividad.dias_semana
        .split(',')
        .map((d) => DIAS_SEMANA[parseInt(d.trim())])
        .filter(Boolean);
      return `Semanal \u00b7 ${dias.join(', ')}`;
    }

    case 'QUINCENAL':
      return 'Quincenal';

    case 'MENSUAL':
      return actividad.dia_mes
        ? `Mensual d\u00eda ${actividad.dia_mes}`
        : 'Mensual';

    default:
      return actividad.patron_recurrencia;
  }
}
